import axios from "axios";
import store from "../store/index";
import router from '@/router'
import config from "@/config";
import { refreshToken,toReauth } from "@core/config/utils";
import Vue from "vue";

export const $http = axios.create({
  baseURL: config.API_BASE_URL,
  //baseURL: "http://8ba2-2401-4900-1c65-33f3-4ac-e5af-e8af-72cf.ngrok.io/api/v1",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: false,
});

$http.interceptors.request.use(async (config) => {
  const keycloak = Vue.prototype.$keycloak;
  await refreshToken()
  config.headers["Authorization"] = 'Bearer ' + keycloak.token;
  //config.headers["Authorization"] =""
  config.headers["MP_ID_TOKEN"] = 'Bearer ' + keycloak.token;
  config.headers["Timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return config;
});

// inject("$http", $http);
$http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response || error.request) {
      const data = error.response || error.request;
      switch (data.status) {
        case 500:
          store.commit("ui/snackbar", {
            title: "Error",
            message: "Something went wrong. Please try again",
            type: "error",
          });
          break;

        case 403:
          router.push('/access-denied')
          break;

        case 401:
          store.dispatch("auth/logout", false);
          toReauth();
          break;

        default:
          return Promise.reject(error);
      }
    }
  }
);
export default $http;
//return $http;
// if (token) {
//   http.setToken(token, 'Bearer ')
// }
